export default {
  textTransform: Styles.textTransform.headlines,
};
